import { render, staticRenderFns } from "./skeleton.vue?vue&type=template&id=2d5221d6&scoped=true"
var script = {}
import style0 from "./skeleton.vue?vue&type=style&index=0&id=2d5221d6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5221d6",
  null
  
)

export default component.exports